// extracted by mini-css-extract-plugin
module.exports = {"sectionOptionPill":"style-module__sectionOptionPill___OOHkR","active":"style-module__active___2Brsb"};